export default "__VITE_ASSET__BoP5R5cj__"